import { PaymentState } from './index';
import { ActionTree } from 'vuex';
import { IStore } from '@store/index';
import { createAdyenSession } from '@store/services/paymentApi';
import { SessionRequest } from "@store/checkout/interfaces/sessionRequest";
import { AxiosError } from "axios";
import { PaymentStatus } from "@store/checkout/inquiry";

export default {
    async startAdyenSession ({ commit, dispatch, rootState, rootGetters }) {
        try {
            const tripData = rootGetters['checkout/getTripDataForAdyen'];

            const sessionRequest: SessionRequest = {
                bookingId: rootGetters['checkout/getBookingId'],
                amount: rootGetters['checkout/openAmountForPaymentInquiry'],
                email: rootGetters['checkout/getContactEmail'],
                country: rootGetters['checkout/getContactIso2'],
                returnUrl: rootGetters['checkout/getPaymentRedirectUrl'],
                ...tripData,
            }

            const response = await createAdyenSession(
                rootState.checkout.apiEndpoint,
                rootState.checkout.apiToken,
                rootState.checkout.checkoutSettings.locale,
                sessionRequest
            );

            commit('setAdyenSession', response.data)
        } catch (error) {
            const err = error as AxiosError;
            const responseStatus = err.response?.status;
            const message = `Error in startAdyenSession | Error code: 1709131990 | HTTP status: ${responseStatus} | ${err.message}`;

            // redirect to payment error page on failing request
            await dispatch('logCheckoutError', err);
            await commit('setPaymentStatus', PaymentStatus.FAILED);
            commit('setIsFinished', true);

            throw Error(message);
        }
    }
} as ActionTree<PaymentState, IStore>
